export default __webpack_public_path__ + "static/media/droparrow.dcab4857.svg";